<template>
  <div id="tabs" class="transform transition-all">
    <div class="tab">
      <button class="tablinks"
              v-for="tab in tabs"
              :class="{ 'active': tab.isActive }"
              :is-last="tab.isLast"
              @click="selectTab(tab)"
      >
        <svg v-if="tab.svg" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="tab.svg"></path>
        </svg>
        <img class="mx-auto" v-if="tab.icon" :src="tab.icon" width="50" height="50" :alt="tab.name"/>
        <span class="block">{{ tab.name }}</span>
      </button>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import LocationAutoComplete from "./LocationAutoComplete";

export default {
  name: "Tabs",

  data() {
    return {
      tabs: [],
      print
    }
  },

  mounted() {
    this.tabs = this.$children;

    window.bus.$on('close-tabs', () => {
      this.closeTabs()
    })
  },

  components: {
    LocationAutoComplete
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.href === selectedTab.href);
      });
    },

    nextTab() {
      let next = false;
      const selectedTab = this.tabs.find(t => t.isActive);

      this.tabs.forEach(tab => {
        tab.isActive = next;
        next = tab.href === selectedTab.href;
      });
    },

    lastTab() {
      const lastTab = this.tabs.find(t => t.isLast);

      this.tabs.forEach(tab => {
        tab.isActive = tab === lastTab;
      });
    },

    closeTabs() {
      this.tabs.forEach(tab => {
        tab.isActive = false;
      });
    },
  },
}
</script>

<style scoped>
button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>